import { render } from "./PortfolioSingle.vue?vue&type=template&id=3a0e00c4&ts=true"
import script from "./PortfolioSingle.vue?vue&type=script&lang=ts"
export * from "./PortfolioSingle.vue?vue&type=script&lang=ts"

import "./PortfolioSingle.vue?vue&type=style&index=0&id=3a0e00c4&lang=scss"

import exportComponent from "/builds/saatsazov/saatsazov-com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__